<template>
  <router-view v-slot="{ Component }" :key=$route.params.Page>
    <keep-alive include="HospitalList, HospitalDetail">
      <component :is="Component" />
    </keep-alive>
  </router-view>
</template>

<script>
export default {
  name: "App",
};
</script>

<style>
#app {
  font-family: "M PLUS 1p", Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.bg {
  background-color: #fcda5e;
}

.sub-bg {
  background-color: #f0ebd7;
}

.prefecture-text {
  color: #af8a61;
}

hr {
  border: 5px solid #fcda5e;
}
</style>
